import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import {WorkingPeriodProps} from 'modules/companies/types';
import weekDaySelect from 'modules/notifications/util/week-day-select';
import QuerySwitch from 'shared/migration-components/query-switch';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import useProductDetails from 'modules/products/hooks/use-product-details';
import productsKeys from 'modules/products/util/products-keys';

const WorkingPeriods: React.FC = () => {
  const {id} = useParams();
  const {data, isLoading} = useProductDetails(id!);
  const navigate = useNavigate();

  const daysOfWeekOrder = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

  const sortByDay = (array: WorkingPeriodProps[]): WorkingPeriodProps[] => {
    return array.sort(
      (a, b) =>
        daysOfWeekOrder.indexOf(a.day.toLowerCase()) -
        daysOfWeekOrder.indexOf(b.day.toLowerCase()),
    );
  };

  return (
    <Table<WorkingPeriodProps>
      loading={isLoading}
      data={sortByDay(data?.workingPeriods ?? [])}
      options={[
        {
          value: 'day',
          column: (row) =>
            weekDaySelect.find((day) => day.value === row.day)?.label,
        },
        {
          value: 'schedules',
          column: (data) =>
            data.schedules
              .map((schedule) => `${schedule.start} - ${schedule.end}`)
              .join(' | '),
        },
        {
          value: 'active',
          column: {
            value: (row) => (
              <QuerySwitch
                isChecked={row.active}
                data={row}
                queryKey={productsKeys.details(id!)}
                url={`/products/${id}/working-periods`}
              />
            ),
            stopPropagation: true,
          },
        },
        {
          label: 'Ações',
          value: 'active',
          column: (row) => (
            <QueryDeleteButton
              queryKey={productsKeys.details(id!)}
              url={`/products/${id!}/working-periods/${row.day}`}
              type="set"
            />
          ),
        },
      ]}
      translatedPropsKey="workingPeriodProps"
      onRowClick={(row) => navigate('create', {state: row})}
    />
  );
};

export default WorkingPeriods;
